<template>
    <b-overlay :show="updating" rounded="sm">
    <div class="unit-measure">
        <b-card :title="componentName" class="inner-page p-3">
            <b-card-body>
                <b-table :items="items" :fields="fields" class="mt-2">
                    <template #cell(control)="{ index, item }">
                        <b-button v-if="index == items.length - 1 && hasPermissionCreate" variant="link"
                            @click="addUnit(item)"><img src="@/assets/images/icon/blue-add.svg" />
                        </b-button>
                        <b-button v-if="index !== items.length - 1 && hasPermissionDelete" variant="pink-button"
                            class="ms-3" @click="deleteNote(index)"><img src="@/assets/images/icon/delete.svg" />
                        </b-button>
                    </template>

                    <template #cell(name)="{ index, item, value }">
                        <b-form-input v-if="index == items.length - 1" :id="`input-name${index}`"
                            :placeholder="$translate('name_of_unit')" v-model="item.name" type="text"></b-form-input>

                        <span v-else>{{ value }}</span>
                    </template>

                    <template #cell(description)="{ index, item, value }">
                        <b-form-textarea v-if="index == items.length - 1" :id="`input-description${index}`"
                            :placeholder="$translate('description')" v-model="item.description" type="text">{{ item.description }}</b-form-textarea>

                        <span v-else>{{ value }}</span>
                    </template>
                </b-table>
            </b-card-body>
        </b-card>
    </div>
    </b-overlay>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'unitMeasures',
    mixins: [popupMixins, permissionsMixins],
    data: () => ({
        model: {
            units: [],
        },
        updating: false,
    }),

    computed: {
        fields() {
            return [
                { key: 'name', label: this.$translate('name_of_unit') },
                { key: 'description', label: this.$translate('description') },
                { key: 'control', label: '' },
            ]
        },
        componentName() { return this.$translate('unit_measure') },
        unitMeasures() {
            const unitMeasures =
                this.$store.getters['company/unitMeasures']
            console.log('computed unitMeasures', unitMeasures)
            return unitMeasures
        },
        items() {
            return [...this.model.units, { name: '', description: '' }]
        },
        settingKeys() {
            return this.$store.state.company.settingKeys.unitMeasureKey
        },
    },

    watch: {
        unitMeasures: {
            handler: function (val) {
                console.log('watch unitMeasures', val)
                this.updateModel(val)
            },
            deep: true,
        },
    },

    async mounted() {
        this.updating = true
        console.log('this.settingKeys', this.settingKeys)
        await this.$store.dispatch(
            'company/fetchConfiguration',
            this.settingKeys
        )
        this.$nextTick(() => {
            this.updateModel(this.unitMeasures)
        })
        this.updating = false
    },

    methods: {
        updateModel(unitMeasures) {
            console.log('update point reached')
            console.log('update unitMeasures', unitMeasures)
            let units = unitMeasures.units || []
            this.model = { units }
            console.log('update model', this.model)
        },

        async updateSettings(type, name,message) {
            try {
                this.updating = true
                const text_value = JSON.stringify(this.model)
                const bool_value = false

               await this.$store.dispatch('company/updateConfiguration', {
                    key: this.settingKeys,
                    text_value,
                    bool_value,
                })

                this.genericToast(this.componentName, type, 'success', `"${name}" ${message}`)


            } catch (error) {
                console.log(error)
                this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                this.updating = false
            }
        },

        addUnit: function ({ name, description }) {
            console.log('model', this.model)
            try {
                if (!name) {
                    throw Error(this.$translate('incomplete_unit_measure_alert'))
                }
                if (!this.$escapeSpecialCharRule.test(name)) {
                    throw Error(this.$translate('regex_unit_measure_alert'))
                }
                if (this.model.units.some(x => x.name.toLowerCase() === name.toLowerCase())) {
                    throw Error(this.$translate('duplicate_unit_measure_alert'))
                }


                this.model.units.push({
                    name,
                    description,
                })
                this.$nextTick(() => {
                    this.updateSettings(this.$translate('created'), name, this.$translate('create_alert'))
                })
            } catch (error) {
                console.log(error.message)

                this.genericToast(`${this.componentName} ${this.$translate('error')}`, '', 'danger', error.message)

            }


        },

        deleteNote: function (index) {
            console.log('>> ', index)
            let currentUnit = this.model.units[index].name
            
            this.model.units.splice(index, 1)
            this.$nextTick(() => {

                this.updateSettings(this.$translate('deleted'), currentUnit, this.$translate('delete_alert'))

            })
        },
    },
}
</script>
